// src/components/admin/AdminAddUserSection.jsx
import React from "react";
import { UserPlus } from "lucide-react";

const AdminAddUserSection = ({ form, setForm, handleSubmit, roleOptions }) => {
  return (
    <div className="max-w-2xl mx-auto w-full" dir="rtl">
      <div className="bg-white/95 backdrop-blur rounded-2xl shadow-xl border border-slate-200/80 px-4 sm:px-6 md:px-8 py-6 sm:py-7">
        {/* Header */}
        <div className="flex w-full items-center justify-start mb-6">
          <div className="flex flex-col items-center gap-3">
            <div className="flex flex-row items-end justify-start text-right">
              <div className="w-10 h-10 ml-3 rounded-2xl bg-gradient-to-br from-sky-500 to-indigo-500 flex items-center justify-center text-white shadow-sm">
                <UserPlus size={22} />
              </div>
              <h2 className="text-base sm:text-lg md:text-xl font-bold text-slate-900 text-right">
                افزودن کاربر جدید
              </h2>{" "}
            </div>
            <div className="flex flex-col items-end text-right">
              <p className="text-[11px] sm:text-xs text-slate-500 text-right">
                ایجاد حساب کاربری برای اعضای جدید سیستم
              </p>
            </div>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5 text-right">
          {/* Username / Email */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
            <div>
              <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
                نام کاربری
              </label>
              <input
                type="text"
                required
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
                ایمیل
              </label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
              رمز عبور
            </label>
            <input
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            />
          </div>

          {/* First / Last name */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
            <div>
              <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
                نام
              </label>
              <input
                type="text"
                value={form.first_name}
                onChange={(e) =>
                  setForm({ ...form, first_name: e.target.value })
                }
                className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
                نام خانوادگی
              </label>
              <input
                type="text"
                value={form.last_name}
                onChange={(e) =>
                  setForm({ ...form, last_name: e.target.value })
                }
                className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
              />
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
              شماره موبایل
            </label>
            <input
              type="text"
              value={form.phone_number}
              onChange={(e) =>
                setForm({ ...form, phone_number: e.target.value })
              }
              placeholder="09123456789"
              className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            />
          </div>

          {/* Role */}
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5 text-right">
              نقش کاربر
            </label>
            <select
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
              className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            >
              {roleOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {/* Submit */}
          <div className="pt-4">
            <button
              type="submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-l from-sky-500 via-indigo-500 to-blue-600 px-4 py-3.5 text-sm sm:text-[0.9rem] font-semibold text-white shadow-lg shadow-sky-900/25 hover:from-sky-600 hover:via-indigo-600 hover:to-blue-700 transition-all"
            >
              ایجاد کاربر جدید
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminAddUserSection;
